import React, { useEffect } from "react";
import { useLanguage } from "../../../utils/languageContext";
import "./DashboardHeader.css";

const LanguageModal = ({ showLanguageModal, setShowLanguageModal }) => {
  const { currentLanguage, changeLanguage, t } = useLanguage();
// ================================Backgound Scroll Stop ================================

    useEffect(() => {
        if (showLanguageModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showLanguageModal]);

    if (!showLanguageModal) return null;
  // =====================================End ===============================================
  const availableLanguages = [
    "English",
    "हिन्दी",
    "বাংলা",
    "తెలుగు",
    "मराठी",
    "தமிழ்",
    "ગુજરાતી",
    "اردو",
    "ಕನ್ನಡ",
    "ଓଡ଼ିଆ",
    "മലയാളം",
    "ਪੰਜਾਬੀ",
    "অসমীয়া",
    "मैथिली",
    "संस्कृत",
    "नेपाली",
    "कोंकणी",
    "মণিপুরী",
    "बड़ो",
    "डोगरी",
    "कॉशुर",
    "ᱥᱟᱱᱛᱟᱲᱤ",
  ];

  const handleLanguageSelect = (language) => {
    const supportedLanguages = [
      "English",
      "हिन्दी",
      "বাংলা",
      "తెలుగు",
      "मराठी",
      "தமிழ்",
      "ગુજરાતી",
      "اردو",
      "ಕನ್ನಡ",
      "ଓଡ଼ିଆ",
      "മലയാളം",
      "ਪੰਜਾਬੀ",
      "অসমীয়া",
      "मैथिली",
      "संस्कृत",
      "नेपाली",
      "कोंकणी",
      "মণিপুরী",
      "बड़ो",
      "डोगरी",
      "कॉशुर",
      "ᱥᱟᱱᱛᱟᱲᱤ",
    ];

    //['English', 'हिन्दी', 'বাংলা', 'தமிழ்', 'मराठी', 'नेपाली', 'মণিপুরী'];

    if (supportedLanguages.includes(language)) {
      changeLanguage(language);
    }
    setShowLanguageModal(false);
  };
  

  if (!showLanguageModal) return null;
  
  return (
    <div
      className="language-modal-overlay-contained"
      onClick={() => setShowLanguageModal(false)}
    >
      <div
        className="language-modal-contained"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="language-modal-header">
          <h5>{t("menu.selectLanguage")}</h5>
          <button
            className="close-btn"
            onClick={() => setShowLanguageModal(false)}
          >
            <span>✕</span>
          </button>
        </div>
        <div className="language-list">
          {availableLanguages.map((language) => (
            <button
              key={language}
              className={`language-item ${
                currentLanguage === language ? "selected" : ""
              }`}
              onClick={() => handleLanguageSelect(language)}
            >
              {language}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
